<template>
    <div class="media-content-v2">
        <div class="media-info">
            <div
                v-if="type === 'text' && (!!title || !!subTitle)"
                class="title-text"
            >
                <site-title
                    :title="title"
                    :size="titleSize"
                    :mbSize="titleMbSize"
                    :align="align"
                    role="heading"
                    :aria-level="1"
                />
                <site-sub-title
                    :title="subTitle"
                    :size="subTitleSize"
                    :mbSize="subTitleMbSize"
                    :align="align"
                    role="heading"
                    :aria-level="3"
                />
                <div
                    v-show="showShadow"
                    class="media-shadow"
                    :style="shadowStyle"
                ></div>
            </div>
            <slot name="info"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        align: {
            type: String,
            default: 'center'
        },
        title: {
            type: String,
            default: ''
        },
        titleSize: {
            type: Number,
            default: 70
        },
        titleMbSize: {
            type: Number,
            default: 35
        },
        subTitle: {
            type: String,
            default: ''
        },
        subTitleSize: {
            type: Number,
            default: 20
        },
        subTitleMbSize: {
            type: Number,
            default: 18
        },
        showShadow: {
            type: Boolean,
            default: false
        },
        shadowStyle: {
            type: Object,
            default: () => ({})
        }
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
@import '../theme/mixin.scss';
.media-content-v2 {
    position: relative;
    z-index: var(--level-sublow);
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-text {
        position: relative;
        .media-shadow {
            position: absolute;
            left: 50%;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            background-color: #000000;
            opacity: 0.6;
            transform: translateX(-50%);
            white-space: nowrap;
        }
        .site-subtitle{
            margin-top: 20px;
            @include media-600 {
                margin-top: 15px;
            }
        }
    }
    .title-image {
        text-align: center;
        margin-bottom: 40px;
        width: 100%;
        overflow: hidden;
        img {
            max-width: 100%;
        }
    }
}
</style>
